"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*!
  Copyright (c) 2019 DynAgility LLC. All rights reserved.
  Licensed under the MIT License.
*/
var immutable_1 = require("immutable");
var constants_1 = require("./constants");
var initialState = immutable_1.Map({});
var actionHandlers = {};
actionHandlers[constants_1.FETCH_URL_START] = function (state, _a) {
    var key = _a.key, method = _a.method, timeout = _a.timeout;
    return state.setIn([key + ":" + method, 'requesting'], true).removeIn([key + ":" + method, 'error']).setIn([key + ":" + method, 'timeout'], timeout);
};
actionHandlers[constants_1.FETCH_URL_SUCCESS] = function (state, _a) {
    var key = _a.key, method = _a.method, result = _a.result, statusCode = _a.statusCode;
    var data = Array.isArray(result) ? immutable_1.List(result) : immutable_1.Map(result);
    return state.setIn([key + ":" + method, 'requesting'], false).setIn([key + ":" + method, 'data'], data).setIn([key + ":" + method, 'statuscode'], statusCode);
};
actionHandlers[constants_1.FETCH_URL_FAILED] = function (state, _a) {
    var key = _a.key, method = _a.method, error = _a.error, statusCode = _a.statusCode;
    return state.setIn([key + ":" + method, 'requesting'], false).removeIn([key + ":" + method, 'data']).setIn([key + ":" + method, 'error'], error).setIn([key + ":" + method, 'statuscode'], statusCode);
};
actionHandlers[constants_1.FETCH_URL_RESET] = function (state, _a) {
    var key = _a.key, method = _a.method;
    return state.remove(key + ":" + method);
};
exports.default = (function (state, action) {
    if (state === void 0) { state = initialState; }
    var nextState = (actionHandlers[action.type] ? actionHandlers[action.type](state, action) : undefined);
    return (nextState !== null && nextState !== undefined ? nextState : state);
});
